import React, { useContext } from 'react';
import {
	ApkAssignmentContext,
	IApkAssignmentContext,
} from 'modules/FirmwareAndApp/Apk/ApkAssignment/apkAssignmentState/apkAssignmentContext';
import SearchField from 'components/SearchField/SearchField';
import style from './Search.module.scss';

const Search: React.FC = () => {
	const { changeSearchString, searchString } = useContext<IApkAssignmentContext>(ApkAssignmentContext);

	return (
		<div className={style.container}>
			<SearchField onChangeSelectSearchString={changeSearchString} searchString={searchString} delay={800} />
		</div>
	);
};

export default Search;
